import { ContentCompletionModel } from '@/domain/models/content/content-completion-model'

export interface ContentCompletion {
  get(id: string): Promise<ContentCompletion.Model>
  post(id: string, form: ContentCompletion.FormData): Promise<void>
}

export namespace ContentCompletion {
  export type Model = ContentCompletionModel
  export const Key = 'content-completion-info'

  export type FormData = {
    certificate: string
    mimeType: string
    rating: number
    comment: string
    acceptedTerms: boolean
    file: File | null
  }
}
